import { apiClient } from "./client";

export const auditLogsApi = {
  list: async (params = {}) => {
    const res = await apiClient.get("/audit/logs/", { params });
    return res.data;
  },

  getMetrics: async (agencyId = null) => {
    const params = agencyId ? { agency: agencyId } : {};
    const res = await apiClient.get("/audit/logs/metrics/", { params });
    return res.data;
  },
};
